/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetType } from './rolloutTargetType';
import { RolloutActionResponse } from './rolloutActionResponse';
import { RolloutTargetState } from './rolloutTargetState';


export interface RolloutTargetResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    /**
     * Rollout Target ID.
     */
    id?: string;
    target_type?: RolloutTargetType;
    /**
     * Rollout Target Entity ID.
     */
    target_entity_id?: string;
    /**
     * Rollout Wave ID.
     */
    wave_id?: string;
    /**
     * Rollout ID.
     */
    rollout_id?: string;
    state?: RolloutTargetState;
    /**
     * List of actions associated with the target.
     */
    actions?: Array<RolloutActionResponse>;
}
export namespace RolloutTargetResponse {
}


